module.exports = __webpack_public_path__ + "static/media/exclamation-mark-yellow.a6bb29d2.svg";